import React, { FC } from 'react';
import { Container } from 'react-bootstrap';
import BaseTemplate from '../BaseTemplate';
import { Button, Label } from '../../atoms';

import styles from './LandscapeProjectsAddProjectsAddContactPersonTemplate.module.css';
import cn from 'classnames';
import { LandscapeAboutContactPersonOrganism } from '../../organisms';
import { LandscapeContactPersonResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-contact-person-response.dto';
import { useNavigate, useParams } from 'react-router-dom';

interface LandscapeProjectsAddProjectsAddContactPersonTemplateProps {
  handleOnChange: (contactPerson: LandscapeContactPersonResponseDto) => void;
  contactPerson: LandscapeContactPersonResponseDto;
  callbackFn: (contactPerson: LandscapeContactPersonResponseDto) => void;
  handleCancel: () => void;
}

const LandscapeProjectsAddProjectsAddContactPersonTemplate: FC<
  LandscapeProjectsAddProjectsAddContactPersonTemplateProps
> = ({ handleOnChange, contactPerson, callbackFn, handleCancel }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <BaseTemplate>
      <Container>
        <div className={cn(styles.heading)}>
          <Label content="Create Project Contact Person" size="lg" />
          <Button
            className={styles.buttonLink}
            variant="link"
            onClick={() =>
              navigate(
                `/landscapes/edit/${id}/projects/add-project/contact-information`
              )
            }
          >
            Go back to overview
          </Button>
        </div>
        <LandscapeAboutContactPersonOrganism
          handleOnChange={handleOnChange}
          callbackFn={callbackFn}
          contactPerson={contactPerson}
          handleCancel={handleCancel}
        />
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeProjectsAddProjectsAddContactPersonTemplate;
